(function () {
  var TEKST = 'Findes i mange størrelser';
  function nulstil() {
    document.querySelectorAll('.grid-product__sizes label[data-edie-mange]').forEach(function (l) {
      l.innerHTML = l.dataset.edieOrig || l.innerHTML;
      delete l.dataset.edieMange;
    });
  }
  function tjek() {
    document.querySelectorAll('.grid-product__sizes label:not([data-edie-mange])').forEach(function (l) {
      if (!l.offsetParent) return;
      var s = l.querySelectorAll('.product-option');
      if (s.length < 2) return;
      if (s[s.length - 1].offsetTop > s[0].offsetTop + 2) {
        l.dataset.edieOrig = l.innerHTML;
        l.innerHTML = '<span class="edie-mange">' + TEKST + '</span>';
        l.dataset.edieMange = '1';
      }
    });
  }
  var t;
  function planlaeg(fuld) {
    clearTimeout(t);
    t = setTimeout(function () { if (fuld) nulstil(); tjek(); }, 120);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', tjek); else tjek();
  window.addEventListener('load', tjek);
  var bredde = window.innerWidth;
  window.addEventListener('resize', function () { if (window.innerWidth !== bredde) { bredde = window.innerWidth; planlaeg(true); } });
  if ('MutationObserver' in window) {
    new MutationObserver(function (m) {
      for (var i = 0; i < m.length; i++) if (m[i].addedNodes.length) { planlaeg(false); return; }
    }).observe(document.body, { childList: true, subtree: true });
  }
})();
